import { QuarryDetailsType } from "../../../../Types/quarryDatabaseTypes";
import { formatNumber } from "../../../../utils/numberFormatterUtil";

export const getFinanceDetails = (quarryDetails: QuarryDetailsType) => [
  {
    value: quarryDetails?.lifeTimePurchases
      ? `$ ${formatNumber(Number(quarryDetails?.lifeTimePurchases).toFixed(2))}`
      : "0",
    label: "Lifetime Revenue",
  },
  {
    value: quarryDetails?.last3Months
      ? `$ ${formatNumber(Number(quarryDetails?.last3Months).toFixed(2))}`
      : "0",
    label: "3 months revenue",
  },
  {
    value: quarryDetails?.last30Days
      ? `$ ${formatNumber(Number(quarryDetails?.last30Days).toFixed(2))}`
      : "0",
    label: "30 days revenue",
  },
  {
    value: quarryDetails?.accountLimit
      ? quarryDetails?.accountLimit
      : "0",
    label: "Charge Limit",
  },
  {
    value: quarryDetails?.accountTerms ? quarryDetails?.accountTerms : "-",
    label: "Terms",
  },
  {
    value: "", // Empty Space
    label: "",
  },
  {
    value: quarryDetails?.currentBalance
      ? `$ ${formatNumber(Number(quarryDetails?.currentBalance).toFixed(2))}`
      : "0",
    label: "Balance",
  },
  {
    value: quarryDetails?.overdueBalance
      ? `$ ${formatNumber(Number(quarryDetails?.overdueBalance).toFixed(2))}`
      : "0",
    label: "Overdue",
  },
  {
    value: "", //Empty Space
    label: "",
  }
];
